var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tab-list",attrs:{"id":"TabList"}},_vm._l((_vm.tabList),function(item,index){return _c('a',{key:index,class:`tab ${_vm.activeIndex === index ? 'tab-active' : 'tab-inactive'}`,style:(index === 0 && { margin: 0 }),on:{"click":() => _vm.handleSelectTab(index)}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }